




















































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import { Prop } from 'vue-property-decorator'
import { TransactionResourceType } from '@/modules/transaction/models/transaction-resource.model'
import TransactionGateWayView from '@/modules/transaction/components/shared/TransactionGateWayView.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import MediaList from '@/modules/media/components/shared/MediaList.vue'

@Component({
  components: { MediaList, CopyableText, PriceView, TransactionGateWayView, BaseCard }
})
export default class AdminTransactionInfo extends Vue {
  @Prop({ required: true }) transaction!: TransactionResourceType

  get transactionData() {
    return this.transaction.data
  }

  protected setProperty(key, value) {
    this.$set(this.transactionData, key, value)
  }
}
